import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/user'

export const patchProfile = async (data) => {
  const response = await apiClient({
      method: 'PATCH',
      url: `${baseEndpoint}/profile`,
      data
  })

  return response?.data
}